import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';

import {
  setEditSbatGroupSelectedInterviewbitTest,
  setEditSbatGroupSelectedSbatGroup,
  setGroupContestCourseType,
  setGroupContestModalState,
} from 'features/classCreation';
import ContestRequirements from '../ContestRequirements';
import Discussion from '../Discussion';
import EditableSection from 'components/EditableSection';
import EditGroupContestModal from '../EditGroupContestModal';
import EditGroupContestSummary from '../EditGroupContestSummary';

export default function EditSbatGroupContestForm({ sbatGroup }) {
  const dispatch = useDispatch();
  const lessons = sbatGroup?.academy_topic?.lessons;
  const { meta, properties } = lessons?.[0] || {};
  const {
    is_group_contest: isGroupContest,
    interviewbit_tests: interviewbitTests,
  } = meta || {};
  const { course_type: courseType } = properties || {};

  useEffect(() => {
    dispatch(setGroupContestCourseType(courseType));
  }, [dispatch, courseType]);

  const handleOpenGroupContestModal = useCallback(
    (setIsEditing) => {
      setIsEditing(false);
      batch(() => {
        dispatch(setEditSbatGroupSelectedSbatGroup(sbatGroup));
        dispatch(
          setEditSbatGroupSelectedInterviewbitTest(interviewbitTests?.[0])
        );
        dispatch(setGroupContestModalState(true));
      });
    },
    [dispatch, interviewbitTests, sbatGroup]
  );

  return (
    <>
      <EditGroupContestModal sbatGroup={sbatGroup} />
      <ContestRequirements sbatGroup={sbatGroup} />
      {isGroupContest && (
        <EditableSection
          canEdit
          handleOnChange={handleOpenGroupContestModal}
          title="Group Contest Summary"
          titleClassName="dark bold"
          className="m-b-s"
        >
          {(editableProps) => (
            <EditGroupContestSummary
              {...editableProps}
              sbatGroup={sbatGroup}
            />
          )}
        </EditableSection>
      )}
      <Discussion sbatGroup={sbatGroup} />
    </>
  );
}
